import { useEffect, useState } from 'react';
import { vehiculesApi } from '../api/resources';
import { useReglages } from '../api/reglages.jsx';
import { CLE_COMPTABLE } from './cloture';

/** Nombre de versements par an, selon la fréquence des honoraires du comptable. */
const FREQ_COMPTABLE = { mensuel: 12, trimestriel: 4, semestriel: 2, annuel: 1 };

/**
 * Les charges de l'année que la comptabilité ajoute aux dépenses : les
 * véhicules (leasing, amortissement) et les honoraires du comptable. L'accueil
 * et les statistiques les ignoraient, et leur bénéfice dépassait celui de la
 * Compta.
 *
 * @returns {{vehicules: object[]|undefined, comptableAnnuel: number, comptable: object|null}} les
 *   fiches des véhicules (absentes tant qu'elles ne sont pas lues) et les
 *   honoraires annuels du comptable
 */
export function useChargesAnnexes() {
  const { reglageJson } = useReglages();
  const [vehicules, setVehicules] = useState(undefined);
  useEffect(() => {
    let actif = true;
    Promise.resolve()
      .then(() => vehiculesApi.liste())
      .then((v) => actif && setVehicules(v || []))
      .catch(() => {});
    return () => {
      actif = false;
    };
  }, []);
  const comptable = reglageJson(CLE_COMPTABLE, null);
  const comptableAnnuel = comptable
    ? (+comptable.montant || 0) * (FREQ_COMPTABLE[comptable.freq] || 1)
    : 0;
  return { vehicules, comptableAnnuel, comptable };
}
